import { pipe } from '../lib/EffectExports';
import { useRequest } from '../hooks/useRequest';
import { chain, sortBy, uniqBy } from 'ramda';
import { useMemo } from 'react';
import { useInfiniteQuery, } from '@tanstack/react-query';
import { graphql } from '../graphql';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
export const RECEIVE_HISTORY = graphql(`
  query GetHistory($lineOfBusiness: String!, $last: Int!, $count: Int!) {
    getConversations(input: { lineOfBusiness: $lineOfBusiness }) {
      lineOfBusiness
      conversationsCount
      conversationFeed(last: $last, count: $count) {
        events {
          id
          persistedTimestamp
          source
          type
          actionEvent {
            action
            remarks
          }
          supportCaseStatusEvent {
            by
            status
            reason
          }
          messageStatusEvent {
            status
            messageId
          }
          messagingStateEvent {
            from
            state
          }
          messageEvent {
            messageType
            from
            text {
              message
            }
            attachment {
              url
              caption
            }
            question {
              text
              options {
                value
                label
                description
                optionType
              }
            }
            command {
              text
              items {
                command
                label
              }
            }
            secureForm {
              invitationId
              url
              title
            }
          }
        }
      }
    }
  }
`);
const PAGE_SIZE = 3;
export const useReceiveHistoryRequest = (opts = {}) => {
    var _a;
    const { lineOfBusiness } = useLineOfBusiness();
    const request = useRequest(RECEIVE_HISTORY, { count: PAGE_SIZE });
    const queryResult = useInfiniteQuery(Object.assign({ queryKey: ['history', lineOfBusiness], queryFn: ({ pageParam }) => request({
            lineOfBusiness: lineOfBusiness,
            last: pageParam,
        }).then((result) => ({
            offset: pageParam,
            result,
        })), initialPageParam: 1, getNextPageParam: ({ offset }) => Math.max(0, offset - PAGE_SIZE), getPreviousPageParam: ({ offset, result }) => Math.min(result.getConversations.conversationsCount, offset + PAGE_SIZE) }, opts));
    const events = useMemo(() => {
        var _a, _b;
        return pipe((_b = (_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.pages) !== null && _b !== void 0 ? _b : [], pages => pages.flatMap(p => p.result.getConversations.conversationFeed), chain(feed => feed.events), uniqBy(ev => ev.id), sortBy(ev => +ev.persistedTimestamp));
    }, [(_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.pages]);
    return Object.assign(Object.assign({}, queryResult), { data: events });
};
//# sourceMappingURL=useReceiveHistoryRequest.js.map